module.exports = __webpack_public_path__ + "static/media/contact.696bbf13.jpg";